import React from 'react';
import styled from 'styled-components';
import InfoTabs from './InfoTabs';
import { Product } from '../../data/products';

interface ProductInfoProps {
  product: Product;
}

const formatPrice = (cents: number): string =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(cents);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg};
`;

const Name = styled.h1`
  font-size: 2.25rem;
  margin: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.75rem;
  }
`;

const Price = styled.span`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.lightText};
  letter-spacing: 0.05em;
`;

const ProductInfo: React.FC<ProductInfoProps> = ({ product }) => (
  <Wrapper>
    <div>
      <Name>{product.name}</Name>
      <Price>{formatPrice(product.price)}</Price>
    </div>
    <InfoTabs description={product.description} materials={product.materials} />
  </Wrapper>
);

export default ProductInfo;
